<template>
    
    <h1 class="page-title">Gestion des taux du produit {{ product.productName }}</h1>
    <br><br>
    <CustomButton :to="{ name: 'jackpot' }" label="Links.goBack" />
    
    
    <div class="form-container">
        <div class="justify-center">
            <div class="mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[40%]">
                <FormKit type="form" 
                    @submit="submitHandler"
                    :actions="false"
                    :model="product"
                    #default="{ value }"
                    :value="true"
                >
                    <div class="w-3/4">
                        <FormKit
                            type="text"
                            name="reductionValue"
                            v-model="product.reductionValue"
                            label="Taux de réduction*"
                            help="Si vous insérez 10, cela revient à 10%"
                        />
                    </div>
                    <div class="w-full mt-5" v-if="product.isContinuousValue">
                        <FormKit
                            type="text"
                            name="minPrice"
                            v-model="product.minPrice"
                            label="Valeur minimale de la carte cadeau*"
                        />
                        <FormKit
                            type="text"
                            name="maxPrice"
                            v-model="product.maxPrice"
                            label="Valeur maximale de la carte cadeau*"
                        />
                    </div>
                    <div class="flex justify-center mt-[1.5rem]">
                        <FormKit
                            type="submit"
                            label="Editer"
                            class="btn"
                        />
                    </div>
                </FormKit>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import CustomButton from "@/components/forms/CustomButton.vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRoute } from "vue-router";
import router from "@/router";

const route = useRoute(); 

const product = ref({
    reductionValue: "",
    minPrice: "",
    maxPrice: "",
    productName: "",
    isContinuousValue:false
});

const fetchData = async (productUuid) => {
    try {
        const response = await ApiService.get(`admin/variant_product_reductions/` + productUuid);
        product.value.reductionValue = response.data.data.reductionValue;
        product.value.minPrice = response.data.data.minPrice 
        product.value.maxPrice = response.data.data.maxPrice 
        product.value.productName = response.data.data.productName;
        product.value.isContinuousValue = response.data.data.isContinuousValue;
    } catch(error) {
        swal.error('An error occurred while fetching datas')
    }
}

onMounted(async () => {
    const productUuid = route.params.uuid
    await fetchData(productUuid);
});

function submitHandler(data, formNode) {
    const uuid = route.params.uuid.toString();
    const reductionValue = parseFloat(String(data.reductionValue).replace(',', '.'));
    const minPrice = product.value.isContinuousValue ? parseFloat(String(data.minPrice).replace(',', '.')) :30;
    const maxPrice = product.value.isContinuousValue ? parseFloat(String(data.maxPrice).replace(',', '.')) :30;

    const validatedFields = {};

    return ApiService.patchWithoutSlug("admin/jackpot-variant-product-reductions/" + uuid, {
        reduction_value: reductionValue,
        min_price: minPrice,
        max_price: maxPrice,
    }).then(() => {
        swal.success("Produit modifié !", "");
        router.push({name: 'jackpot'});
    }).catch(({response}) => {
        response.data.errors.forEach((error) => {
            if (!validatedFields[error.property]) {
                formNode.setErrors(null, { [error.property]: error.message });
                validatedFields[error.property] = true;
            }
        });
    });
}
</script>